/**
 * @generated SignedSource<<08881f72d885ed5a3a3864a32b31457d>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type Avatar_actor$data = {
  readonly name: string;
  readonly avatar: {
    readonly transformedSrc: string;
  } | null;
  readonly " $fragmentType": "Avatar_actor";
};
export type Avatar_actor$key = {
  readonly " $data"?: Avatar_actor$data;
  readonly " $fragmentSpreads": FragmentRefs<"Avatar_actor">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "size"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "Avatar_actor",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "name",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Image",
      "kind": "LinkedField",
      "name": "avatar",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": [
            {
              "kind": "Variable",
              "name": "maxHeight",
              "variableName": "size"
            },
            {
              "kind": "Variable",
              "name": "maxWidth",
              "variableName": "size"
            },
            {
              "kind": "Literal",
              "name": "scale",
              "value": 2
            }
          ],
          "kind": "ScalarField",
          "name": "transformedSrc",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Actor",
  "abstractKey": "__isActor"
};

(node as any).hash = "b1bb7a03e568b26955810d11e962dd73";

export default node;
